import "./Header.styl";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { connect } from "react-redux";

import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import Menu from "./Menu";

const Logo = ({ appPath }) => (
  <div className="logo">
    <a href={"/"}>
      <div className="logo-text">OpiekujSie.pl</div>
    </a>
  </div>
);

const Header = ({ title, appPath }) => (
  <header className="hidden-md-down">
    <div className="width-wrapper">
      <Row className="flex-items-xs-middle">
        <Col xs="2">
          <Logo appPath={appPath} />
        </Col>
        <Col className="text-xs-right" xs="10">
          <Menu />
          <Link
            className="btn btn-lg btn-secondary button-action"
            to={`${appPath}/dodaj-ogloszenie`}
          >
            Dla pracodawców
          </Link>
        </Col>
      </Row>
    </div>
  </header>
);

export default connect(
  state => ({
    appPath: state.config.appPath
  }),
  {}
)(Header);



/** WEBPACK FOOTER **
 ** ./src/browser/components/Header/Header.js
 **/